module.exports = __webpack_public_path__ + "img/barrier.b1275cad.svg";